export const isSyncConsultation = (
  isSyncExperience?: boolean,
  requiresPrescriberCall?: boolean,
): boolean => {
  return !!(isSyncExperience && requiresPrescriberCall);
};
